import { useState } from 'react';

export default function SmartImg({ className = '', alt = '', ...props }) {
  const [state, setState] = useState('pending');

  const cls = [className, state === 'ok' ? 'img-ok' : '', state === 'error' ? 'img-error' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <img
      alt={alt}
      {...props}
      className={cls}
      onLoad={(e) => {
        if (e.currentTarget.naturalWidth > 0) setState('ok');
      }}
      onError={() => setState('error')}
    />
  );
}
